import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import VocabularyCardItems from '../containers/VocabularyCardItems';

const VocabularyCards = ({
  category,
  handleScroll,
  items,
  itemsPerRow,
  readErrors,
  readStatus,
}) => (
  <InfiniteScrollCards
    className="aridhia-vocabulary-cards"
    entity="vocabulary"
    handleScroll={handleScroll}
    icon="font"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
  >
    <VocabularyCardItems items={items} category={category} />
  </InfiniteScrollCards>
);

export default VocabularyCards;
